<template>
	<div class="box" ref="mainRight" id="rightCont">
	<!-- 头部图标页面名称 -->
	<div class="main" id="main">
		<div class="header">
			<div class="header-tab">
				<div class="iconTitle">
					<i class="el-icon-lszt" style="border-radius: 50%;font-size: 20px;padding: 2px;margin-left: 8px;background-color: #409EFF;color: #fff;"></i>
					<span style="font-weight:400;margin-left: 12px;font-size: 12px;">{{CatalogueName}}</span>
				</div>
				<div class="tabs">
					<el-tabs v-model="activeName" @tab-click="tabsHandleClick">
						<el-tab-pane label="草稿"   name="0"></el-tab-pane>
						<el-tab-pane label="已提交" name="2"></el-tab-pane>
						<el-tab-pane label="已审核" name="4"></el-tab-pane>
						<el-tab-pane label="已过单" name="5"></el-tab-pane>
						<el-tab-pane label="已冲销" name="6"></el-tab-pane>
					</el-tabs>
				</div>
			</div>
			<!-- btn2 -->
			<div class="header-bottom">
				<el-select v-model="ksValue" @clear="clearKs" clearable placeholder="申请科室" size="mini" style="width: 94px;">
					<el-option
					  v-for="item in optionks"
					  :key="item.id"
					  :label="item.label"
					  :value="item.label">
					  <span style="float: left;font-size: 12px">{{ '编码：' + item.code }}</span>
					  <span style="float: right;font-size: 12px">{{ '名称：' + item.label }}</span>
					</el-option>
				</el-select>
				<!-- 供货单位 -->
				<el-select v-model="GysValue" @clear="clearGys" clearable placeholder="供货单位" size="mini" style="width: 158px;">
					<el-option
					  v-for="item in gysOption"
					  :key="item.id"
					  :label="item.label"
					  :value="item.label">
					  <span style="float: left;font-size: 12px">{{ '名称：' + item.label }}</span>
					  <span style="float: right;font-size: 12px">{{ '许可证号：' + item.permitNumber }}</span>
					</el-option>
				</el-select>
				<!-- 药品名称 -->
				<el-select v-model="drugValue" @clear="clearDrug" clearable placeholder="药品名称" size="mini" style="width: 158px;">
					<el-option
					  v-for="item in drugOption"
					  :key="item.id"
					  :label="item.label"
					  :value="item.label">
					  <span style="float: left;font-size: 12px">{{ '名称：' + item.label }}</span>
					  <span style="float: right;font-size: 12px">{{ '批准文号：' + item.approvalNumber }}</span>
					</el-option>
				</el-select>
				<!-- 时间 -->
				<el-select v-model="dateTimeValue" placeholder="创建时间" size="mini" style="width: 99px;">
					<el-option
					  v-for="item in dateTimeOption"
					  :key="item.id"
					  :label="item.label"
					  :value="item.label">
					  <span style="float: left;font-size: 12px">{{  item.label }}</span>
					</el-option>
				</el-select>
				<!-- dateTimer -->
				<div class="block">
					<el-date-picker v-model="startDate" type="datetime" size="mini" placeholder="选择开始时间" align="right" 
						:picker-options="pickerOptions" @change="startDateHandle"> 
					</el-date-picker>
					<el-date-picker v-model="endDate" type="datetime" style="margin-left: 8px;" size="mini" placeholder="选择结束时间" align="right"
						:picker-options="pickerOptions" @change="endDateHandle">
					 </el-date-picker>
				</div>
				<!-- 查找按钮 -->
				<el-button size="mini" :loading="loading" type="info" @click="found" icon="el-icon-Ssearch">查询</el-button>
				<!-- 重置按钮 -->
				<el-button size="mini" plain type="info" @click="rest">重置</el-button>
			</div>
			<!-- 按钮 -->
			<div class="header-btns">
				<div class="feetBtn">
					<el-button v-for="(v,i) in feetBtn" :key="i" :type="v.type" :disabled="v.disabled"
					:loading="loading" :icon="v.icon" size="mini" @click="feetHandClick(v,i)">{{ v.title }}</el-button>
				</div>
				<div class="headBtn">
					<el-button v-for="(v,i) in headerBtn" :key="i" :type="v.type" :loading="loading" :icon="v.icon" size="mini"
					 @click="handClick(v,i)">{{ v.title }}</el-button>
					 <!-- 展开/折叠按钮 -->
					 <el-tooltip :content="isExpanded ? '折叠' : '展开'" placement="top" style="margin-left: 12px;">
					 	<i :class="isExpanded ? 'el-icon-bumenOpen' : 'el-icon-maximize'" 
					 	@click="toggleExpandAll" style="cursor: pointer; margin-right: 8px;"></i>
					 </el-tooltip>
					 <!-- tooltipBtns -->
					 <div class="tooltips" v-for="(item,index) in tooltipBtns" :key="item.title">
						 <!-- 循环图标按钮 -->
						 <el-tooltip :content="item.title" :placement="item.type">
						 	<i :class="item.icon" @click="tooltipsHand(item,index)" style="cursor: pointer; margin-right: 8px;"></i>
						 </el-tooltip>
					 </div>
				</div>
			</div>
		</div>
		<!-- table -->
		<div class="table">
			<el-table 
			  ref="table"
			  :data="tableData" 
			  :max-height="tableHeight"
			  highlight-current-row 
			  @current-change="handleCurrentTableChange" 
			  show-summary 
			  :summary-method="getSummaries"
			  :row-key="getRowKeys"
			  :default-expand-all="false"
			>
			<!-- 添加多选列 -->
			<!-- <el-table-column 
			  type="selection" 
			  width="50"
			  align="center">
			</el-table-column> -->
			<!-- 修改展开列 -->
			<el-table-column type="expand" width="50" fixed="left" class-name="custom-expand-column">
				<template slot-scope="props">
				  <div class="expand-content-wrapper" style="height: 60px;">
					<el-descriptions 
					  class="margin-top" 
					  :column="8" 
					  border
					  size="mini"
					>
					<el-descriptions-item label="单据编号">{{ props.row.docNum }}</el-descriptions-item>
					<el-descriptions-item label="业务日期">{{ props.row.busDate }}</el-descriptions-item>
					<el-descriptions-item label="供货单位">{{ props.row.supplierName }}</el-descriptions-item>
					<el-descriptions-item label="申请人">{{ props.row.createName }}</el-descriptions-item>
					<el-descriptions-item label="制单时间">{{ props.row.createTime }}</el-descriptions-item>
					<el-descriptions-item label="合计金额">{{ props.row.totalAmt }}</el-descriptions-item>
					<el-descriptions-item label="审核人">{{ props.row.reviewName }}</el-descriptions-item>
					<el-descriptions-item label="审核时间">{{ props.row.reviewTime }}</el-descriptions-item>
					<el-descriptions-item label="过单人">{{ props.row.passingOrdersName }}</el-descriptions-item>
					<el-descriptions-item label="过单时间">{{ props.row.passingOrdersTime }}</el-descriptions-item>
					<el-descriptions-item label="作废人">{{ props.row.nullifyId }}</el-descriptions-item>
					<el-descriptions-item label="作废时间">{{ props.row.nullifyTime }}</el-descriptions-item>
				  </el-descriptions>
					</div>
				  </template>
			</el-table-column>
			<!-- 表格行rows -->
			<!-- <el-table-column prop="id" label="系统序号"></el-table-column> -->
			<el-table-column prop="docNum" label="单据编号" width="168">
				<template slot-scope="{ row }">
					<span style="color: #00557f;font-weight: bold;">{{ row.docNum }}</span>
				</template>
			</el-table-column>
			<el-table-column prop="busDate" label="业务日期" width="168">
				<template slot-scope="{ row }">
					<span style="font-weight: bold;">{{ row.busDate }}</span>
				</template>
			</el-table-column>
			<el-table-column prop="status" label="状态">
				 <template slot-scope="{ row }">
					<!-- 根据state显示不同的图标 -->
					<div class="stateValue" style="border-radius: 4px;background-color: #e2fff6;text-align: center;color: #004a00;">
						<i :class="statusIconMap[row.state]" :style="{ color: statusColorMap[row.state] }"></i>
						<span>{{ statusMap[row.state] || '未知状态' }}</span>
					</div>
				</template>
			</el-table-column>
			<el-table-column v-for="(col, inx) in tableRows" :key="inx" :type="col.type" :prop="col.prop" :label="col.name" :width="columnWidth(col, tableData)"></el-table-column>
			<!-- fixed -->
			<el-table-column fixed="left" label="行号" type="index" width="68" align="center"></el-table-column>
			<!-- edit -->
			<el-table-column fixed="right" label="操作" width="128">
				  <template slot-scope="scope">
					<div class="editbox" v-if="scope.row.state == 0">
						<el-link type="info" @click="handleClickEdit(scope.row)" size="mini" style="font-size: 12px;">修改</el-link>
						<el-link type="danger" @click="handleDelete(scope.row)" size="mini" style="margin-left: 12px;font-size: 12px;">删除</el-link>
					</div>
					<div class="editbox" v-else style="text-align: center;">
						<!-- 根据state显示不同的图标 -->
						<i :class="statusIconMap[scope.row.state]" :style="{ color: statusColorMap[scope.row.state] }"></i>
						<span>{{ statusMap[scope.row.state] || '未知状态' }}</span>
					</div>
				  </template>
				</el-table-column>
			</el-table>
		</div>
		
		<!-- feet -->
		<div class="feet">
			<!-- 分页 -->
			<el-pagination
			style="margin: 12px;"
			@size-change="handleSizeChange"
			@current-change="handleCurrentChange"
			:current-page="pageNum"
			:page-sizes="[20,50,100]"
			:page-size="pageSize"
			:total="totalSize"
			layout="total, sizes, prev, pager, next, jumper"
			background>
			</el-pagination>
		</div>
	</div>
	
		<!-- add dialog -->
		<div class="addDiglog">
		<!-- <el-dialog title="新增采购计划" :visible.sync="addDialogVisible" width="68%" :before-close="handleClose"> -->
			<addDiglog ref='sonRef' :parent-method="loadData"></addDiglog>
		<!-- </el-dialog> -->
		</div>
		<!-- 修改 -->
		<div class="editdiglog">
			<!-- <editDiglog ref='editSonRef' @Update="loadData" :parent-method="loadData"></editDiglog> -->
		</div>
		<!-- 审核过单 -->
		<div class="editdiglog">
			<exaDiglog ref='exaRef' @Update="loadData" :parent-method="loadData" @refresh="handleRefresh"></exaDiglog>
		</div>
	</div>

</template>

<script>
	// selfs / props
	import addDiglog from "./addReturnDiglog.vue"; //新增Model
	import exaDiglog from "./exaReturnDiglog.vue"; //审核.过单Model
	
	// selfs / js
	import addForm from './addForm.js' //Form表单
	// xter
	// 接口
	import { dugRetnPage,getWare,selectDropDownList,deleteRetn,dugRetnExamine } from "@/api/MedicenHouse/Western.js";
	// import { dugRetnPage,getWare,selectDropDownList,deleteRetn,dugRetnExamine } from "@/api/PSI/shopReturn.js";
	export default{
		components:{
			addDiglog,exaDiglog
		},
		data(){
			return{
				// str
				windowWidth:'', //右侧表格动态宽度
				iconComes:'el-icon-shopping-cart-2',
				CatalogueName:'其他出库【西药房】',
				nameTitle:'其他出库【西药房】',
				DropDownedName:'全部单据',
				selectedValue:'',
				selectedValueGys:'', // 供应商选择
				tableHeight:'570', // table的高度，以便超出高度显示滚动条
				currentHeight:'', // 用于计算table的高度，以便超出高度显示滚动条
				// blean
				isExpanded: false, // 控制展开/折叠状态
				loading:false,
				dialogVisible:false,
				showFeetBtn:false,
				gdDialogVisible: false,
				isAllSelected: false, // 新增：是否全选
				auditStatus:'',
				startDate:'', //开始时间
				endDate:'', //结束时间
				formattedDate: '', // 用于存储格式化后的日期时间
				// number
				state:'', // 状态
				pageNum: 1, //当前页currentPage
				pageSize: 20,
				totalSize: 0, //总条数
				activeName:'a',
				ksValue:'',
				GysValue:'',
				dateTimeValue:'创建时间',
				undefined:'未知错误！请联系管理员', // 错误提示
				drugValue:'',
				// arr title右侧按钮
				headerBtn:[
				 { title:"刷新", type:"top", icon:"el-icon-refresh" },
				 { title:"打印", type:"", icon:"el-icon-printer" },
				 { title:"高级选项", type:"", icon:"el-icon-lcyt" },
				],
				tooltipBtns:[
				 { title:"导出", type:"top", icon:"el-icon-finished" },
				 // { title:"打印", type:"top", icon:"el-icon-printer" },
				 // { title:"导出", type:"", icon:"el-icon-finished" },
				 { title:"关闭", type:"top", icon:"el-icon-close" },
				],
				selecteds:[
				  { title:"全部单据", command:"a" },{ title:"已提交", command:"b" },{ title:"已审核", command:"c" },
				  { title:"已过单", command:"d" },{ title:"已作废", command:"e" },
				],
				// 添加多选数据
				multipleSelection: [], // 存储选中的行数据
				// 页面默认按钮// 基础按钮配置（始终显示）
				defaultButtons:[
					{ refesh:"refesh", title:"冲销", type:"danger", icon:"el-icon-lszt" },
					// { refesh:"refesh", title:"新增", type:"success", icon:"el-icon-adds" },
					{ refesh:"refesh", title:"提交", type:"primary", icon:"el-icon-finished" },
					{ refesh:"refesh", title:"审核", type:"primary", icon:"el-icon-document-checked" },
					{ refesh:"refesh", title:"过单", type:"primary", icon:"el-icon-sort" },
					{ refesh:"refesh", title:"查看明细", type:"primary", icon:"el-icon-printer" },
				],
				// 最终使用的按钮数组
				feetBtn: [],
				optionks:[{id:1,code:'001',label:'西药库'}],
				dateTimeOption:[{id:1,label:'创建时间'},{id:2,label:'提交时间'},{id:3,label:'审核时间'},{id:4,label:'过单时间'}],
				drugOption: [],
				// 单据状态 0 草稿,1 回退提交,2 已提交,3 回退审核,4 已审核,5 已过单,6 已作废'
				statusOption:[
					{id:0,label:'草稿'},{id:1,label:'回退提交'},{id:2,label:'已提交'},{id:3,label:'回退审核'},{id:4,label:'已审核'},{id:5,label:'已过单'},{id:6,label:'已作废'},
				], 
				gysOption:[],
				options:[{value: '制单时间',label: '制单时间'},{value: '过单时间',label: '过单时间'},{value: '操作时间',label: '操作时间'},{value: '业务日期',label: '业务日期'}],
				currentTable: [],//表格单选
				tableRows:[
					{ name:"供货单位", prop:"supplierName", type:"" },{ name:"成本金额", prop:"costAmt"},{ name:"销售金额", prop:"saleAmt"},
					{ name:"申请人", prop:"createName", type:"" },{ name:"制单时间", prop:"createTime", type:"" },
					{ name:"审核人", prop:"reviewName", type:"" },{ name:"审核时间", prop:"reviewTime", type:"" },{ name:"过单人", prop:"passingOrdersName", type:"" },
					{ name:"过单时间", prop:"passingOrdersTime", type:"" },{ name:"作废人", prop:"nullifyId", type:"" },{ name:"作废时间", prop:"nullifyTime", type:"" },
				],
				pickerOptions: {
				  shortcuts: [
					{ text: '今天', onClick(picker) { picker.$emit('pick', new Date()); }}, 
					{ text: '昨天', onClick(picker) { const date = new Date();date.setTime(date.getTime() - 3600 * 1000 * 24);picker.$emit('pick', date);}}, 
					{ text: '一周前',onClick(picker) {const date = new Date();date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);picker.$emit('pick', date);}},
					{ text: '最近一个月',onClick(picker) {const date = new Date();date.setTime(date.getTime() - 3600 * 1000 * 24 * 30);picker.$emit('pick', date);}},
					{ text: '最近三个月',onClick(picker) {const date = new Date();date.setTime(date.getTime() - 3600 * 1000 * 24 * 90);picker.$emit('pick', date);}},
					{ text: '半年前',onClick(picker) {const date = new Date();date.setTime(date.getTime() - 3600 * 1000 * 24 * 180);picker.$emit('pick', date);}},
					{ text: '去年',onClick(picker) {const date = new Date();date.setTime(date.getTime() - 3600 * 1000 * 24 * 360);picker.$emit('pick', date);}},
					]
				},
				computed: {
				  // 计算属性判断是否是多选状态
				  isMultipleSelected() {
				    return this.multipleSelection.length > 1;
				  },
				  // 计算属性判断是否是单条选中
				  isSingleSelected() {
				    return this.multipleSelection.length === 1;
				  },
				  // 计算属性判断是否有选中项
				  hasSelection() {
				    return this.multipleSelection.length > 0;
				  }
				},
				tableData: [],
				addForm:{}, // 新增参数 => 改状态 form表单 * 
				//props
				statusMap: {
					0: '待提交',
					1: '回退提交',
					2: '待审核',
					3: '回退审核',
					4: '待过单',
					5: '已过单',
					6: '已作废'
				},
				statusIconMap: {
					0: 'el-icon-document',
					1: 'el-icon-top-left',
					2: 'el-icon-check',
					3: 'el-icon-bottom-right',
					4: 'el-icon-document-checked',
					5: 'el-icon-success',
					6: 'el-icon-delete'
				},
				statusColorMap: {
					0: '#909399',
					1: '#67C23A',
					2: '#409EFF',
					3: '#E6A23C',
					4: '#409EFF',
					5: '#409EFF',
					6: '#F56C6C'
				},
			}
		},
		mounted() {
			this.addForm = addForm.map(v => {return v })[0]; // Form
			// 获取当前日期时间
			this.getNowDateTime();
			//获取动态盒子宽度，实时赋值给右侧 => this.$refs.mainRight.offsetWidth;
			this.$nextTick(()=>{
				this.updateWindowWidth();
				window.addEventListener('resize', this.updateWindowWidth);
				this.initButtons(); // 引入全局自定义封装方法
			})
			this.tjsqrq = new Intl.DateTimeFormat('zh-CN').format(new Date());5
			this.tjsqr = JSON.parse(localStorage.getItem('userInfo')).username;
			this.addForm.nullifyId = JSON.parse(localStorage.getItem('userInfo')).userId;
			// 加载数据源
			this.loadData();
			this.currentHeight = this.$getHeights();
			this.getTableHeight();
			this.getGys();
			this.getDrug();
		},
		methods:{
			async loadData(){
				let res = await dugRetnPage({
					state:this.state,
					startDate:this.startDate,
					endDate:this.endDate,
					pageNum:this.pageNum,
					pageSize:this.pageSize,
				});
				if(res.code === 200){
					this.tableData = res.data.content
					this.totalSize = res.data.totalSize
				}else{
					// this.$message({ type: 'error', message: res.message });
					this.tableData = [];
				}
			},
			// 权限按钮
			initButtons() {
			    // 获取当前路由路径
			    const currentPath = this.$route.path;
			    // 获取路由对应的权限按钮
			    const routeButtons = this.$getRouteButtons(currentPath);
				console.log(routeButtons,'routeButtonsrouteButtons');
			    // 合并到现有按钮数组
			    this.feetBtn = this.$mergeButtons(this.defaultButtons, routeButtons);
				console.log(this.feetBtn,'feetBtnfeetBtn');
			},
			// 在methods部分添加刷新方法
			handleRefresh() {
			  this.loadData(); // 调用原有的数据加载方法
			},
			// 添加多选变化事件
			// handleSelectionChange(val) {
			//     this.multipleSelection = val;
			//     // 判断是否多选（选择超过1个）
			//     const isMultiple = val.length > 1;
			    
			//     // 更新按钮状态
			//     this.updateButtonStates(isMultiple);
			// },
			  
			// 更新按钮状态
			// updateButtonStates(isMultiple) {
			//     this.feetBtn = this.feetBtn.map(button => {
			//       // 如果是"新增"或包含"导入"的按钮，始终不禁用
			//       if (button.title == '新增' || button.title.includes('新增') || button.title.includes('导入')) {
			//         return {
			//           ...button,
			//           disabled: false
			//         };
			//       }
			      
			//       // 如果是多选状态，禁用其他按钮
			//       return {
			//         ...button,
			//         disabled: isMultiple
			//       };
			//     });
			// },
			// 用于计算table的高度，以便超出高度显示滚动条
			getTableHeight(){
				let headerHeight = this.currentHeight.mainHeight
				let feetHeight = this.currentHeight.feetHeight
				let lastHeight = this.currentHeight.lastHeight
				this.tableHeight = this.currentHeight.rightContentHeight - feetHeight * 3
				console.log(this.tableHeight,'this.tableHeightthis.tableHeight');
			},
			// 选项卡切换事件
			tabsHandleClick(tab, event) {
				console.log(tab, tab.label);
				if(tab.name == '0'){
					this.state = 0;
					this.loadData();
				}else if(tab.name == '2'){
					this.state = 2;
					this.loadData();
				}else if(tab.name == '4'){
					this.state = 4;
					this.loadData();
				}else if(tab.name == '5'){
					this.state = 5;
					this.loadData();
				}else if(tab.name == '6'){
					this.state = 6;
					this.loadData();
				}
			},
			async getGys(){
				// 供应商下拉列表
				let rs = await selectDropDownList()
				this.gysOption = rs.data.content.map(obj => {
				  // 将 name 替换为 label，并保留其他字段
				  return { label: obj.supplierName , ...obj };
				});
			},
			async getDrug(){
				// 药品下拉列表
				let res = await getWare()
				this.drugOption = res.data.content.map(obj => {
				  // 将 name 替换为 label，并保留其他字段
				  return { label: obj.drugName , ...obj };
				});
			},
			// 计算激活步骤（关键逻辑）
			calcActive(state) {
			  // 状态码与步骤索引的映射关系 => 状态0对应第1个步骤（索引从1开始）
			  const stateMap = { 0:1, 1:2, 2:3, 3:4, 4:5, 5:6, 6:7 }
			  // 返回当前状态对应的步骤索引 如果找不到则默认为0（不激活任何步骤）
			  return stateMap[state] || 0
			  // 或者更简单的数学计算（如果状态码是连续数字）： return Math.min(state + 1, this.statusOption.length)
			},
			// 开始时间变化值
			startDateHandle(value) {
				if (value) {
					// 使用 JavaScript 的 Date 对象格式化日期
					this.startDate = this.formatDate(value);
					// this.loadData();
					this.getTableHeight();
				} else {
					this.startDate = '';
				}
			},
			// 结束时间变化值
			endDateHandle(value){
				if (value) {
				  // 使用 JavaScript 的 Date 对象格式化日期
				  this.endDate = this.formatDate(value);
				  // this.loadData();
				  this.getTableHeight();
				} else {
					this.endDate = '';
				}
			},
			// table合计行
			getSummaries(param) {
				const { columns, data } = param;
				const sums = [];
				columns.forEach((column, index) => {
				  if (index === 1) {
					sums[index] = '总计：';
					return;
				  }else if(index != 7 && index != 8){
					sums[index] = '';
					return;
				  }
				  const values = data.map(item => Number(item[column.property]));
				  if (!values.every(value => isNaN(value))) {
					sums[index] = values.reduce((prev, curr) => {
					  const value = Number(curr);
					  if (!isNaN(value)) {
						return prev + curr;
					  } else {
						return prev;
					  }
					}, 0);
					sums[index] += '（RMB）';
				  } else {
					sums[index] = '';
				  }
				});
				return sums;
			},
			// 修改原有的handleCurrentTableChange方法
			handleCurrentTableChange(val) {
			  this.currentTable = val;
			  // 如果是单选，更新多选数组
			  // if (val) {
			  //   // 找到当前行在表格数据中的索引
			  //   const index = this.tableData.findIndex(item => item.id === val.id);
			  //   // 设置该行的选中状态
			  //   this.$nextTick(() => {
			  //     this.$refs.table.toggleRowSelection(this.tableData[index], true);
			  //   });
			  //   this.multipleSelection = [val];
			  // } else {
			  //   this.multipleSelection = [];
			  // }
			  // this.updateButtonStates();
			},
			// 循环图标事件
			tooltipsHand(v){
				console.log(v);
				if(v.title == '导出' || v.title.includes('导出')){
					this.$message.error('导出为Excel，Fail!');
				}else if(v.title == '关闭' || v.title.includes('关闭')){
					// 关闭当前页
					setTimeout(() =>{
						window.history.back();
					},888)
				}
			},
			found(){
				// console.log(this.GysValue ,'this.GysValue this.GysValue ');
				this.loadData();
			},
			// 展开/折叠所有行
			toggleExpandAll() {
			  // 切换状态
			  this.isExpanded = !this.isExpanded;
			  
			  // 获取表格实例
			  const table = this.$refs.table;
			 //  if(this.tableData.length === 0){
				// // 显示提示信息
				// this.$message({ type: 'success', message: '当前表格暂无数据' });
			 //  }
			  // 根据当前状态展开或折叠所有行
			  this.tableData.forEach(row => {
			    table.toggleRowExpansion(row, this.isExpanded);
			  });
			  // 显示提示信息
			  // this.$message({ type: 'success', message: this.isExpanded ? '已展开所有行' : '已折叠所有行' });
			},
			// 草稿编辑
			handleClickEdit(row){
				row.nameTitle = '编辑'
				console.log(row);
				if(row.state == 0){
					this.$refs.sonRef.open(row) //打开编辑Model
				}else{
					this.$message.error('只有草稿单据才能被修改!');
				}
			},
			// 草稿删除
			handleDelete(row) {
				if(row.state == 0){
					this.$confirm("此操作将永久删除此退库单据, 是否继续?", "提示", {
					  confirmButtonText: "确定",
					  cancelButtonText: "取消",
					  type: "warning",
					})
					  .then(async() => {
						// 状态 => 作废 
						this.addForm.id = row.id;
						let result = await deleteRetn({ ids: row.id });
						if (result.code === 200) {
							this.$message({ type: 'success', message: result.message });
							this.loadData(); // 更新数据驱动
						} else {
							this.$message.error(result.message)
						}
					  })
					  .catch(() => {
						this.$message({ type: "info",message: '已取消'});
					  });
				}else{
					this.$message.error('只有草稿单据才能被删除!');
				}
			},
			// 当前日期时间
			formatDate(date) {
			      const year = date.getFullYear();
			      const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从 0 开始，需要加 1
			      const day = String(date.getDate()).padStart(2, '0');
			      const hours = String(date.getHours()).padStart(2, '0');
			      const minutes = String(date.getMinutes()).padStart(2, '0');
			      const seconds = String(date.getSeconds()).padStart(2, '0');
			      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
			},
			// 将当前日期时间设置为夜晚十一点五十九分
			getNowDateTime(){
				// 获取当前日期时间
				const now = new Date();
				// 格式化日期时间
				// 将时间设置为凌晨十二点
				const midnight = new Date(now);
				midnight.setHours(0, 0, 0, 0);
				this.startDate = this.formatDate(midnight);
				// 将时间设置为夜晚十一点五十九分
				const evening = new Date(now);
				evening.setHours(23, 59, 0, 0);
				this.endDate = this.formatDate(evening);
			},
			// 时间处理
			changDate(val){
				let i = this.idx
				switch(i) {
					case 5:
					function formatDate(date) {
					  const year = date.getFullYear();
					  const month = (date.getMonth() + 1).toString().padStart(2, '0');
					  const day = date.getDate().toString().padStart(2, '0');
					  return `${year}-${month}-${day}`;
					}
					const now = new Date();
					this.addForm.busDate = formatDate(val);
				}
			},
			getRowKeys(row) {
			    return row.id; // 使用行的唯一标识作为key
			},
			// 重置按钮
			rest(){
				this.ksValue = '';
				this.GysValue = '';
				this.drugValue = '';
				this.startDate = '';
				this.endDate = '';
			},
			GysSelected(){
				this.loadData();
			},
			// 打印按钮点击事件
			handlePrint() {
			  this.$confirm('请选择打印方式', '打印设置', {
			    confirmButtonText: 'Lodop打印',
			    cancelButtonText: '浏览器打印',
			    type: 'warning'
			  }).then(() => {
			    // 用户选择Lodop打印
				console.log('用户选择Lodop打印');
			    this.printWithLodop();
			  }).catch(() => {
			    // 用户选择浏览器打印
			    // this.printWithBrowser()
				console.log('用户选择浏览器打印');
			  })
			},
			// 使用Lodop打印并设计
			printWithLodop() {
				  // 准备表格数据
				  const tableData = this.tableData.map(item => {
				    return {
				      ...item,
				      // 添加任何需要转换的字段
				    };
				  });
				  
				  // 准备当前选中行数据
				  const currentTable = this.currentTable;
				  
				  this.$router.push({
				    path: '/PrintTemplateDesigner',
				    query: {
				      tableData: JSON.stringify(tableData),
				      currentTable: JSON.stringify(tableData),
				      templateName: this.CatalogueName
				    }
				});
			},
			// 清空科室选项
			clearKs(){
				this.ksValue = '';
				// this.loadData();
			},
			// 清空供货单位选项
			clearGys(){
				this.GysValue = '';
				// this.loadData();
			},
			// 清空药品名称选项
			clearDrug(){
				this.drugValue = '';
				// this.loadData();
			},
			// headers commond
			handleCommand(command) {
			  // console.log(command);
			  // 根据 command 值执行相应的逻辑
			  switch (command) {
				case 'a':
				  // 处理a的逻辑
				  this.auditStatus = ''
				  this.DropDownedName = '全部单据'
				  this.loadData();
				  break;
				case 'b':
				  // 处理b的逻辑
				  this.auditStatus = 2
				  this.DropDownedName = '已提交'
				  this.loadData();
				  break;
				case 'c':
				  // 处理b的逻辑
				  this.auditStatus = 4
				  this.DropDownedName = '已审核'
				  this.loadData();
				  break;
				// ... 其他 case
				case 'd':
				  // 处理b的逻辑
				  this.auditStatus = 5
				  this.DropDownedName = '已过单'
				  this.loadData();
				  break;
				case 'e':
				  // 处理e的逻辑
				  this.auditStatus = 6
				  this.DropDownedName = '已作废'
				  this.loadData();
				  break;
			  }
			},
			// 步骤
			handClick(v,i) {
				// i event
				// 处理逻辑 => 打印
				if(v.title == '打印' || v.title.includes('打印')){
					this.handlePrint();
				}
				switch (i) {
					case 0:
						// 处理索引0的逻辑 页面刷新
						this.loading = true;
						setTimeout(() => {
							this.loadData();
							this.$message({type:'success',message:'已刷新'})
							this.loading = false;		
						}, 1500)
						break;
					case 1:
						// 处理索引1的逻辑
						this.$confirm('敬请2期待')
							.then(_ => {})
							.catch(_ => {});
						break;
					case 2:
						// 处理索引2的逻辑 => 新增
						this.dialogVisible = true
						break;
					
				}
			},
			feetHandClick(v,i){
				// 获取当前操作按钮
				const button = this.feetBtn[i];
				// 如果按钮被禁用，直接返回
				if (button.disabled) {
					this.$message.warning('当前操作不可用');
					return;
				}
				// 处理逻辑 => 新增
				if(v.title == '新增' || v.title.includes('新增')){
					// 处理索引2的逻辑 => 新增 -> 调用子组件
					let pam = {
						nameTitle : '新增'
					}
					this.$refs.sonRef.open(pam);
				}
				// 处理逻辑 => 修改
				else if (v.title == '修改' || v.title.includes('修改')){
					// 处理索引1的逻辑 => 修改
					if(this.currentTable.length != 0){
						this.currentTable.nameTitle = '修改'
						console.log(this.currentTable,'this.currentTable');
						this.$refs.sonRef.open(this.currentTable);
					}else{
						this.$message({ type: 'warning', message: '请先选择一条数据'});
					}
				}
				// 处理逻辑 => 冲销
				else if (v.title == '冲销' || v.title.includes('冲销')){
					if(this.currentTable.length === 0){
						this.$message({ type: 'warning', message: '请先单击选择一条数据'});
					}else if(this.currentTable.state != 5){
						this.$message({ type: 'error', message: '只能冲销已过单的数据！'});
					}else{
						if(this.currentTable){
							this.$confirm("确定需要作废选中的单据吗?", "提示", {
							  confirmButtonText: "确定",
							  cancelButtonText: "取消",
							  type: "warning",
							})
						  .then(async() => {
							// 状态 => 作废 
							this.addForm.id = this.currentTable.id;
							this.addForm.state = 6;
							let result = await dugRetnExamine(this.addForm)
							if (result.code === 200) {
								this.$message({ type: 'success', message: '已作废！'});
								this.loadData(); // 更新数据驱动
							} else {
								this.$message.error('fail！')
							}
						  })
						  .catch(() => {
							this.$message({ type: "info",message: '已取消'});
						  });
						}
					}
				}
				// 处理逻辑 => 查看
				else if(v.title == '查看' || v.title.includes('查看')){
					if(this.currentTable.length === 0){
						this.$message({ type: 'warning', message: '请先单击选择一条数据'});
					}else{
						this.currentTable.name = '查看'
						this.$refs.exaRef.openModel(this.currentTable)
					}
				}
				// 处理逻辑 => 提交
				else if(v.title == '提交' || v.title.includes('提交')){
					if(this.currentTable.length === 0){
						this.$message({ type: 'warning', message: '请先单击选择一条数据'});
					}else if(this.currentTable.state != 0){
						this.$message({ type: 'error', message: '只能提交草稿数据！'});
					}else{
						this.currentTable.name = '草稿'
						this.$refs.exaRef.openModel(this.currentTable)
					}
				}
				// 处理逻辑 => 审核
				else if(v.title == '审核' || v.title.includes('审核')){
					if(this.currentTable.length === 0){
						this.$message({ type: 'warning', message: '请先单击选择一条数据'});
					}else if(this.currentTable.state != 2){
						this.$message({ type: 'error', message: '只能审核已提交的数据！'});
					}else{
						this.currentTable.name = '审核'
						this.$refs.exaRef.openModel(this.currentTable)
					}
				}
				// 处理逻辑 => 过单
				else if(v.title === '过单' || v.title.includes('过单')){
					if(this.currentTable.length === 0){
						this.$message({ type: 'warning', message: '请先单击选择一条数据'});
					}else if(this.currentTable.state != 4){
						this.$message({ type: 'error', message: '只能过单已审核的数据！'});
					}else{
						this.currentTable.name = '过单'
						this.$refs.exaRef.openModel(this.currentTable)
					}
				}
				// 处理逻辑 => 关闭
				else if(v.title === '关闭' || v.title.includes('关闭')){
					setTimeout(() =>{
						window.history.back();
					},888)
				}
				// 处理逻辑 => 未知错误
				else{
					this.$message({ type: 'danger', message: this.undefind });
				}
				// i event
			},
			// db events
			// col 里面包含了表头字段和名称，list 是表格数据
			columnWidth(col, list) {
			  let prop = col.prop,lab = col.lab;
			  let width = 20; // 设定一个最小值
			  let maxlenStr = ""; // 最长字符串
			  for (let info of list) {
				if (maxlenStr < (info[prop] + "").length) maxlenStr = info[prop];
			  }
			  width = Math.max(width, len(lab), len(maxlenStr));
			  // 表格自带的内边距(20px) 自调
			  return width + 20; // 这里加了 12px
			  function len(str) {
				// 实际分配长度可根据需要自行调整
				let length = 12;
				for (const char of str + "") {
				  // 英文小写字符 8px
				  if ("a" <= char && char <= "z") length += 8;
				  // 数字
				  else if (Number.isFinite(Number(char))) length += 12;
				  // 英文大写字符 8px
				  else if ("A" <= char && char <= "Z") length += 8;
				  // 中文字符 28px
				  else if (char >= "\u4e00" && char <= "\u9fa5") length += 22;
				  // 其他 8px
				  else length += 12;
				}
				return length;
			  }
			},
			// addDiglog Close
			handleClose(done) {
				this.$confirm('确认关闭？')
				  .then(_ => {
					done();
				  })
				  .catch(_ => {
				});
			},
			//分页
			//每页条数改变触发
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
				this.pageNum = val;
				this.loadData();
			},
			//当前条数改变触发
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				this.pageNum = val;
				this.loadData();
			},
			// 实时宽度
			updateWindowWidth() {
				this.windowWidth = window.innerWidth - 188;
			},
		},
		filters: {
		formatTime(timestamp) {
		  if (!timestamp) return 'N/A'
		  return dayjs(timestamp).format('YYYY-MM-DD HH:mm:ss')
		}
		},
	}
</script>

<style lang="less" scoped>
	/deep/ .el-tabs__item{
		font-size: 12px;
	}
	/deep/ .el-tabs__header{
		margin: 0px;
	}
	.box{
		display: flex;
		flex-direction: column;
		height: calc(100vh - 64px); // 减去导航栏高度
		width: 100%;
		overflow: hidden;
		.main {
			flex: 1;
		    display: flex;
		    flex-direction: column;
		    overflow: hidden;
		.header{
			flex-shrink: 0; /* 防止header被压缩 */
			background-color: #fff;
			.header-tab{
				display: flex;
				border-bottom: 1px solid #dcdfe6;
				align-items: center;
				.iconTitle{
					display: flex;
					align-items: center;
				}
				.tabs{
					padding-left: 8px;
				}
			}
			.header-bottom{
				background-color: #fff;
				/deep/ .el-select>.el-input{
					height: 28px;
					line-height: 28px;
				}
				gap:8px;
				display: flex;
				align-items: center;
				justify-content: start;
				width: 100%;
				height: 40px;
				line-height: 40px;
				flex-wrap: wrap;
				.main-icon-b{
					display: flex;
					align-items: center;
					padding: 12px;
					width: 100%;
					margin-left: 12px;
				}
			}
			.header-btns{
				display: flex;
				justify-content: space-between;
				height: 40px;
				padding: 8px;
				line-height: 60px;
				align-items: center;
				background-color: #f1f1f1;
				.headBtn{
					display: flex;
					align-items: center;
				}
				.feetBtn{
					display: flex;
					align-items: center;
				}
			}
		}
		.table{
			flex: 1;
			overflow: hidden;
			// background-color: #00557f;
			/deep/ .el-table {
				flex: 1;
				display: flex;
				flex-direction: column;
				width: 100%;
				height: 100% !important; /* 强制表格高度填充容器 */
			    // height: 100% !important;
				.el-table__header-wrapper {
				  flex-shrink: 0;
				}		
				.el-table__footer-wrapper {
				  position: sticky;
				  bottom: 0;
				  background-color: #f5f7fa;
				  z-index: 1;
				  box-shadow: 0 -1px 10px rgba(0, 0, 0, 0.1);
				}
			    /* 确保表格主体可以滚动 */
				.el-table__body-wrapper {
				  overflow-y: auto;
				  // overflow-x: hidden;
				}
				
				/* 处理展开行高度 */
				.el-table__expand-column {
				  .cell {
					padding: 0;
				  }
				}
			}
			/deep/ .el-table .cell{
			}
			/deep/ .el-table th{
				color: #2d2d2d;
				font-weight: bold;
				font-size: 12px;
				height: 18px;
				line-height: 18px;
			}
			/deep/ .el-table th.el-table__cell>.cell{
				border-right: 2px solid #ececec;
				height: 18px;
				line-height: 18px;
			}
			/deep/ .el-table td.el-table__cell div{
				font-size: 12px;
				height: 18px;
				line-height: 18px;
			}
			// padding: 16px;
			/* 自定义高亮颜色 */
			::v-deep .el-table__body tr.current-row > td {
			  background-color: #55aaff !important;
			  color: #f9f9f9; /* 可选：修改文字颜色 */
			}
		}
		.feet {
		  flex-shrink: 0; /* 防止footer被压缩 */
		  height: 40px;
		  display: flex;
		  justify-content: flex-end;
		  align-items: center;
		  padding: 0 20px;
		  background-color: #f5f7fa;
		  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
		  z-index: 10;
		  
		  /deep/ .el-pagination {
			margin: 0 !important;
		  }
		}
		}
	}
</style>